<template>
  <div>
    <v-app-bar
      id="home-app-bar"
      app
      color="transparent"
      flat
      height="76"
    >
      <router-link
        :to="{ name: 'Home' }"
        class="hh-logo"
        aria-label="Hacker Hang home"
      >
        <span class="hh-logo__brace hh-logo__brace--open">{</span>
        <span class="hh-logo__name">Hacker Hang</span>
        <span class="hh-logo__brace hh-logo__brace--close">}</span>
      </router-link>

      <v-spacer />

      <div>
        <v-tabs
          class="hidden-sm-and-down"
          background-color="transparent"
          optional
        >
          <v-tab
            v-for="(name, i) in items"
            :key="i"
            :to="{ name }"
            :exact="name === 'Home'"
            :ripple="false"
            active-class="hh-tab--active"
            class="hh-tab"
            min-width="80"
            text
          >
            {{ name }}
          </v-tab>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        aria-label="Open menu"
        @click="drawer = !drawer"
      />
    </v-app-bar>

    <home-drawer
      v-model="drawer"
      :items="items"
    />
  </div>
</template>

<script>
  export default {
    name: 'HomeAppBar',

    components: {
      HomeDrawer: () => import('./Drawer'),
    },

    data: () => ({
      drawer: null,
      items: [
        'Home',
        'Products',
        'Vision',
        'Contact',
      ],
    }),
  }
</script>

<style lang="sass">
  #home-app-bar
    background: rgba(6, 4, 26, .72) !important
    backdrop-filter: blur(14px)
    border-bottom: 1px solid var(--hh-line)

    .v-toolbar__content
      padding-left: 24px
      padding-right: 24px

    .v-tabs-slider
      display: none

    .hh-tab
      text-transform: none
      letter-spacing: 0
      font-weight: 500
      font-size: .95rem
      color: var(--hh-muted) !important

      &::before
        display: none

      &:hover
        color: var(--hh-text) !important

    .hh-tab--active
      color: var(--hh-cyan) !important

  .hh-logo
    display: inline-flex
    align-items: baseline
    gap: 6px
    text-decoration: none
    font-family: var(--hh-font-display)
    font-weight: 500
    font-size: 1.55rem
    letter-spacing: -0.02em
    color: var(--hh-text)

    &__brace
      font-size: 1.7rem
      line-height: 1

      &--open
        color: var(--hh-cyan)

      &--close
        color: var(--hh-magenta)
</style>
